import template from './flight-segment-alternatives.html';

const DIRECTIVE_NAME = FlightSegmentAlternatives.DIRECTIVE_NAME = 'ktFlightSegmentAlternatives';
export default function FlightSegmentAlternatives() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: FlightSegmentAlternativesController,
        controllerAs: '$ctrl',
        scope: {
            segment: `=${DIRECTIVE_NAME}`,
            recommendation: `=${DIRECTIVE_NAME}Recommendation`,
            selectedFlights: `=${DIRECTIVE_NAME}SelectedFlights`,
            onSelectGroup: `&${DIRECTIVE_NAME}OnSelectGroup`,
        },
        link: function($scope, $elem, $attrs, flightSegmentAlternativesCtrl) {
            flightSegmentAlternativesCtrl.$onInit();
        },
    };
}

export function FlightSegmentAlternativesController(
    flightSegmentService,
    flightSegmentAlternativesService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        selectGroup,
        doesOverlapSiblingSegments,
    });

    function $onInit() {
        initGroups();
    }

    function initGroups() {
        const group = flightSegmentService.getSelectedGroup(vm.selectedFlights, vm.segment);
        vm.groups = vm.segment.FlightGroups.filter(({FlightGroupId}) => FlightGroupId !== group.FlightGroupId);
    }

    function selectGroup(group) {
        if (doesOverlapSiblingSegments(group)) {
            return;
        }
        flightSegmentService.selectGroup(vm.selectedFlights, vm.segment, group);
        vm.onSelectGroup();
        initGroups();
    }

    function doesOverlapSiblingSegments(group) {
        return flightSegmentAlternativesService.doesOverlapSiblingSegments(vm.recommendation, vm.segment, group, vm.selectedFlights);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-segment/flight-segment-alternatives/flight-segment-alternatives-component.js